import { CountryUrl, Entity } from '@/enums';

export const getRoute = (pathname: string) => {
  const isDev = process.env.NODE_ENV == 'development';

  // pathname = /{country}/{entity}/{page}
  // !isDev pathname = /edp/tripcare360/{country}/{entity}/{page}
  const [, country, entity, page] = pathname.split('/').slice(isDev ? 0 : 2);

  return {
    country: country as CountryUrl,
    entity: entity as Entity,
    page,
  };
};
